import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-cut-large.tsx
/**
* icon.24.cut.large
*
* Keywords: scissors, cut-action, trim, tool, editing, crop, blade, removal
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNC4yMzggMTYuOTRhLjUuNSAwIDAgMS0uNDc2LS44OGw2LjIzLTMuMzc1YS41LjUgMCAwIDEgLjQ3Ny44OHptOC4wNzQtNS41MUw0LjIzOCA3LjA1NWEuNS41IDAgMCAwLS40NzYuODhsOC4yNTUgNC40NzFhLjUuNSAwIDAgMCAuMTA4LjA1OGwxLjk5NiAxLjA4Mi0uMzQ3IDIuMzc1YTMuMTUgMy4xNSAwIDAgMCAxLjYxOCAzLjIzbC40NC4yMzhhMi42NjIgMi42NjIgMCAwIDAgMi41MzUtNC42OGwtMy40NTItMS44Ny0uMDItLjAxMi0xLjUzMy0uODMgMS41MzMtLjgzLjAyLS4wMTIgMy40NTItMS44N2EyLjY2MiAyLjY2MiAwIDAgMC0yLjUzNi00LjY4bC0uNDM5LjIzOGEzLjE1IDMuMTUgMCAwIDAtMS42MTggMy4yM2wuMzQ4IDIuMzc1em0yLjQ1MS0zLjUwMS4yOTUgMi4wMTMgMi44MzItMS41MzVhMS42NjIgMS42NjIgMCAwIDAtMS41ODItMi45MjJsLS40NC4yMzhhMi4xNSAyLjE1IDAgMCAwLTEuMTA1IDIuMjA2bTAgOC4xMzguMjk1LTIuMDEzIDIuODMyIDEuNTM0YTEuNjYyIDEuNjYyIDAgMCAxLTEuNTgyIDIuOTIzbC0uNDQtLjIzOGEyLjE1IDIuMTUgMCAwIDEtMS4xMDUtMi4yMDYiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-2420
*/
const Icon24CutLarge = memo(function Icon24CutLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M4.238 16.94a.5.5 0 0 1-.476-.88l6.23-3.375a.5.5 0 0 1 .477.88zm8.074-5.51L4.238 7.055a.5.5 0 0 0-.476.88l8.255 4.471a.5.5 0 0 0 .108.058l1.996 1.082-.347 2.375a3.15 3.15 0 0 0 1.618 3.23l.44.238a2.662 2.662 0 0 0 2.535-4.68l-3.452-1.87-.02-.012-1.533-.83 1.533-.83.02-.012 3.452-1.87a2.662 2.662 0 0 0-2.536-4.68l-.439.238a3.15 3.15 0 0 0-1.618 3.23l.348 2.375zm2.451-3.501.295 2.013 2.832-1.535a1.662 1.662 0 0 0-1.582-2.922l-.44.238a2.15 2.15 0 0 0-1.105 2.206m0 8.138.295-2.013 2.832 1.534a1.662 1.662 0 0 1-1.582 2.923l-.44-.238a2.15 2.15 0 0 1-1.105-2.206",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24CutLarge };

//# sourceMappingURL=icon-24-cut-large.js.map